import { ColumnDescription } from "react-bootstrap-table-next";
import { ListarAnexosVendaController } from "../../../../../Controllers/Geral/InformacoesVenda/InformacoesVendaControllers";
import useAsyncEffect from "../../../../../hooks/useAsyncEffect";
import { IAnexoVenda } from "../../../../../Interfaces/Geral/InformacoesVenda/InformacoesVendaInterfaces";
import Table from "../../../../Table";
import LeiaMais from "../../../../Utils/LeiaMais";

interface IAnexosVendaProps {
    ID_CHAVE_ERP: string;
}

export default function AnexosVenda(props: IAnexosVendaProps) {
    const { value: lstAnexosVenda, loading } = useAsyncEffect(
        () => ListarAnexosVendaController(props.ID_CHAVE_ERP),
        [props.ID_CHAVE_ERP]
    );
    return (
        <Table
            data={lstAnexosVenda ?? []}
            columns={columns}
            keyField="key"
            loading={loading}
            striped
            bordered={false}
            noDataIndication={
                <div className="text-muted text-center">
                    Nenhum anexo nessa venda
                </div>
            }
            defaultStyle={{
                align: "center",
                classes: "p-2",
            }}
            wrapperClasses="x-scroll"
        />
    );
}

const columns: Array<ColumnDescription<IAnexoVenda>> = [
    {
        dataField: "NumeroAtendimento",
        text: "Número do Atendimento",
    },
    {
        dataField: "Descricao",
        text: "Descrição",
        formatter: (c) => <LeiaMais charLimit={250}>{c}</LeiaMais>,
    },
    {
        dataField: "StatusAtendimento",
        text: "Status",
    },
    {
        dataField: "UsuarioReponsavel",
        text: "Usuário responsável",
    },
    {
        dataField: "DataAtendimento",
        text: "Data",
        formatter: (c) => new Date(c).toLocaleDateString(),
    },
];
